import { useContext, useEffect, useState } from "react";
import styles from "./screenResult.module.scss";
import CurrentContext from "../utils/CurrentContext";
import Button from "./button";

export default function Result() {
  const {
    aspectRatio,
    setName,
    setEmail,
    answers,
    scoreStat,
    setCurrentScreen,
  } = useContext(CurrentContext);
  const correctCount = answers.filter((a) => a.correct).length;
  const percentage = Math.round((correctCount / answers.length) * 100);
  function HandleClick() {
    setName("");
    setEmail("");
    setCurrentScreen("start");
  }
  return (
    <div className={styles.result_wrapper}>
      {aspectRatio > 1 ? (
        <div className={styles.result_content}>
          <div className={styles.answer_panel}>
            <div className={styles.thumbnails}>
              {answers.map((ans, i) => (
                <div className={styles.thumbnail} key={i}>
                  <div
                    className={`${styles.thumb_result} ${
                      ans.correct ? styles.correct : styles.wrong
                    }`}
                  >
                    You chose: {ans.selected === "right" ? "Imagine" : "Real"}
                  </div>
                  <div
                    className={styles.thumb_img}
                    style={{ backgroundImage: `url(${ans.src})` }}
                  />
                  <img src="" alt=""/>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.score_panel}>
            <h2>Your Score</h2>
            <div className={styles.score_circle}>{percentage}%</div>
            {scoreStat ? (
              scoreStat.map((s, i) => (
                <p key={i}>
                  {s.count} scored {s.name}
                </p>
              ))
            ) : (
              <p>Loading stats...</p>
            )}

            <div className={styles.startBtnWrapper}>
              <Button label="Play Again" handleClick={HandleClick} />
            </div>
          </div>
        </div>
      ) : (
        <div
          className={styles.result_content}
          style={{ flexDirection: "column" }}
        >
          <div className={styles.score_panel} style={{ width: "100%", flexGrow:"1" }}>
            <h2>Your Score</h2>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "2rem",
              }}
            >
              <div className={styles.score_circle}>{percentage}%</div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                {scoreStat ? (
                  scoreStat.map((s, i) => (
                    <p key={i}>
                      {s.count} scored {s.name}
                    </p>
                  ))
                ) : (
                  <p>Loading stats...</p>
                )}
              </div>
            </div>

            <div
              className={styles.startBtnWrapper}
              style={{ marginBottom: "1rem" }}
            >
              <Button label="Play Again" handleClick={HandleClick} />
            </div>
          </div>
          <div className={styles.answer_panel}>
            <div
              className={styles.thumbnails}
              style={{ display: "flex", flexWrap: "wrap", justifyContent:"center" }}
            >
              {answers.map((ans, i) => (
                <div className={styles.thumbnail} key={i}
                style={{
                  backgroundImage: `url(${ans.src})`,
                  height: "9vh",
                  width: "9vh",
                }}>
                  <div
                    className={`${styles.thumb_result} ${
                      ans.correct ? styles.correct : styles.wrong
                    }`}
                    style={{ fontSize: "75%" }}
                  >
                    You chose: {ans.selected === "right" ? "Imagine" : "Real"}
                  </div>
                  <div
                    className={styles.thumb_img}
                    style={{
                      backgroundImage: `url(${ans.src})`
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
